import { storyblokSettingsKey } from '~/plugins/storyblok'

export const useStoryblokSettings = () => {
  const storyblokSettings = inject(storyblokSettingsKey)

  if (storyblokSettings === undefined) {
    throw new Error('Trying to use storyblokSettings before the custom storyblok nuxt plugin has been started.')
  }
  return storyblokSettings
}
